import { Container } from '@mui/material';
import HeaderBreadcrumbs from '../../../components/HeaderBreadcrumbs';
import Page from '../../../components/Page';
import { useParams } from 'react-router-dom';
import AddOnProductVariantForm from './AddonProductVariantForm';

const index = () => {
  const params: any = useParams();
  const isAddMode = !params?.id;
  return (
    <Page title={'Add-on Product Variant'}>
      <Container maxWidth={'xl'}>
        <HeaderBreadcrumbs
          heading={`${isAddMode ? 'Add Add-on Product Variant' : 'Edit Add-on Product Variant'} `}
          links={[
            { name: 'Dashboard', href: '/' },
            { name: 'Add-on Product', href: '/addon-product-variant' },
          ]}
        />
        <AddOnProductVariantForm />
      </Container>
    </Page>
  );
};

export default index;
